module.exports = __webpack_public_path__ + "img/Brochure-Sonnet-SMALL.baa51f58.jpg";